export interface IEventListener{
	onEvent(_:Event) : void;
}


export class Event{
	public type:string;
	public target:EventDispatcher;
	public data:any;

	constructor( type:string, data:any = null ){
		this.type = type;
		this.data = data;
	}
}


export class EventDispatcher{

	private listeners:IEventListener[];

	constructor(){
		this.listeners = [];
	}

	public dispatch( event : Event ){
		for( let listener of this.listeners ){
			event.target = this;
			listener.onEvent( event );
		}
	}

	public addListener( listener:IEventListener ){
		if( this.listeners.includes(listener) ){
			console.log("[WARN] Trying to add same listener twice");
			return;
		}
		this.listeners.push( listener );
	}
	


}
